import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import PrincipalProcessActions from '../../Stores/PrincipalProcess/Actions';

import PrincipalList01Table from '../PrincipalList01/PrincipalList01Table';

const { TabPane } = Tabs;

class PrincipalProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchPrincipalProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchPrincipalProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchPrincipalProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchPrincipalProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/principalProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'PRINCIPAL_LIST_01' && <PrincipalList01Table match={match} />}
      </Card>
    );
  }
}

PrincipalProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchPrincipalProcess: PropTypes.func
};

PrincipalProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchPrincipalProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.principalProcess.process,
  processIsLoading: state.principalProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchPrincipalProcess: () =>
    dispatch(PrincipalProcessActions.principalProcessFetchPrincipalProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PrincipalProcessScreen));
